<template>
  <v-menu
    offset-y
    left
    :nudge-bottom="8"
    transition="slide-y-transition"
    attach
  >
    <template v-slot:activator="{ on, value }">
      <v-btn
        icon
        slot="activator"
        v-on="on"
        :aria-expanded="value ? 'true' : 'false'"
      >
        <v-icon>apps</v-icon>
      </v-btn>
    </template>

    <v-card class="my-essentials">
      <v-container fluid>
        <slot name="header">
          <v-row
            :class="{'mb-5 mt-3': $props.title || $props.essentialText || $props.essentialUrl}"
            justify="space-between"
            no-gutters
            v-if="!$slots.header"
          >
            <v-col>
              <span class="title">{{ title }}</span>
            </v-col>
            <v-col>
              <a
                :href="essentialUrl"
                class="linkColor"
                target="_blank"
              >{{ essentialText }}</a>
            </v-col>
          </v-row>
        </slot>

        <v-row>
          <v-col
            class="text-center"
            v-for="app in mappedData"
            :key="app.id"
            xs="4"
          >
            <div>
              <a>
                <svg :class="'icon ' + app.iconClass">
                  <use v-bind="{ 'xlink:href': app.xlinkHref }" />
                </svg>
                <span
                  class="appTitle two-lines body-1"
                  :aria-label="app.title"
                  :title="app.title"
                >{{ app.title }}</span>
              </a>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  name: "MyEssentials",
  props: {
    essentialsData: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: null
    },
    essentialText: {
      type: String,
      default: null
    },
    essentialUrl: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      iconToClass: window.iconToClass
    }
  },
  computed: {
    mappedData() {
      return this.essentialsData.map((data) => {
        if (data.icon in this.iconToClass) {
          return {
            ...data,
            iconClass: this.iconToClass[data.icon],
            icon: data.icon.substring(3),
            xlinkHref: '#' + data.icon.substring(3)
          };
        }
        return data;
      });
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../styles/variables.scss';

.my-essentials {
  width: 23rem;
}

.icon {
  width: 3.875rem;
  height: 3.875rem;
  border-radius: 7px;
}

.appTitle {
  display: block;
  color: $ads-dark;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 110px;
  margin: 0 auto;
  white-space:nowrap;
 &.two-lines {
  -webkit-line-clamp: 2;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  white-space: normal;
 }
}

.linkColor {
  color: $ads-blue-2;
}
</style>
